module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "factoring_main w"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "condition"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "condition_list"
  }, _vm._l((_vm.conditionArr), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "condition_li"
    }, [_c('span', [_vm._v(_vm._s(item.compactName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.compactMain))])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bill"
  }, [_c('div', {
    staticClass: "factoring_tit w"
  }, [_c('h2', {
    staticClass: "factoring_h"
  }, [_vm._v("票据业务")]), _vm._v(" "), _c('div', {
    staticClass: "limit"
  }, [_vm._v("\n        凭证贴现：对凭证提前贴现获得流动资金。录入票据或者接收上级供应商支付的凭证获得可贴现的金额  拆分支付：对凭证拆分向下级供应商")]), _vm._v(" "), _c('button', {
    staticClass: "factoring_btn"
  }, [_vm._v("立即申请")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bill_main"
  }, [_c('ul', {
    staticClass: "bill_list"
  }, [_c('li', [_vm._v("电子商业汇票")]), _vm._v(" "), _c('li', [_vm._v("纸质商业汇票")]), _vm._v(" "), _c('li', [_vm._v("银行商业汇票")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow"
  }, [_c('p', {
    staticClass: "flow_h tit_public colorF"
  }, [_c('span', {
    staticClass: "tit_span"
  }, [_vm._v("申请流程")])]), _vm._v(" "), _c('div', {
    staticClass: "flow_img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/bill.png"),
      "alt": "申请流程"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "condition_h tit_public"
  }, [_c('span', {
    staticClass: "tit_span"
  }, [_vm._v("申请条件及所需资料")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da882f22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Bill.vue
// module id = 1096
// module chunks = 1